import { AttendanceListResponse } from '../types';

export function useFormatData(data: AttendanceListResponse['data']) {
  return data.map((attendance) => {
    const justificationFiles = attendance.teacherFileGroup || [];
    const observationFiles = attendance.adminFileGroup || [];
    const allFiles = [...justificationFiles, ...observationFiles];
    return {
      id: attendance.id,
      responsible: attendance.responsible,
      faculty: attendance.school,
      course: attendance.course,
      section: attendance.section,
      date: attendance.date,
      moduleStart: attendance.initModule,
      moduleEnd: attendance.endModule,
      status: attendance.status,
      justification: attendance.justification,
      justificationStatus: attendance.justificationStatus,
      justificationDate: attendance.justificationDate,
      adminObservation: attendance.adminObservation,
      observationAdminName: attendance.observationAdminName,
      observationDate: attendance.observationDate,
      teacherFileGroup: attendance.teacherFileGroup.map((file: any) =>
        parseInt(file.id, 10),
      ),
      adminFileGroup: attendance.adminFileGroup.map((file: any) =>
        parseInt(file.id, 10),
      ),
      [`validationComplementaryFilesIds_${attendance.id}`]: allFiles.map(
        (e: any) => ({
          ...e,
        }),
      ),
    };
  });
}
